export var POSITION_REVAMP_DATA = "POSITION_REVAMP_DATA";
export var POSITION_REVAMP_FILTERDATA = "POSITION_REVAMP_FILTERDATA";
export var POSITION_REVAMP_SUMMARIZE = "POSITION_REVAMP_SUMMARIZE";
export var POSITION_REVAMP_SEARCH = "POSITION_REVAMP_SEARCH";
export var POSITION_SORT_DATA = "POSITION_SORT_DATA";
export var POSITION_SQOFF_VALUES = "POSITION_SQOFF_VALUES";
export var POSITION_SQOFF_ADDMORE = "POSITION_SQOFF_ADDMORE";
export var POSITION_SQOFF_CUSTOM_PAYLOAD = "POSITION_SQOFF_CUSTOM_PAYLOAD";
export var POSITION_SELECTED_DATA = "POSITION_SELECTED_DATA";
export var SET_LIST_OF_CHECKED_ITEMS = "SET_LIST_OF_CHECKED_ITEMS";
export var REQUIRED_ORDER_SLICING = "REQUIRED_ORDER_SLICING";
export var MODIFY_POSITION_ORDER = "MODIFY_POSITION_ORDER";
export var POSITION_REVAMP_LOADER = "POSITION_REVAMP_LOADER";
export var POSITION_REVAMP_STOP_LOADER = "POSITION_REVAMP_STOP_LOADER";
export var POSITION_REVAMP_ERROR = "POSITION_REVAMP_ERROR";
export var POSITION_REVAMP_HIDE_ERROR = "POSITION_REVAMP_HIDE_ERROR";
export var POSITION_REVAMP_ADD_MSG = "POSITION_REVAMP_ADD_MSG";
export var POSITION_REVAMP_CLEAR_MSG = "POSITION_REVAMP_CLEAR_MSG";
export var POSITION_RESET_ALL_DATA = "POSITION_RESET_ALL_DATA";
